import { render, staticRenderFns } from "./CRUDContratoTemplates.vue?vue&type=template&id=8b124888&"
import script from "./CRUDContratoTemplates.vue?vue&type=script&lang=js&"
export * from "./CRUDContratoTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports